<template>
    <div>
        <div class="image" v-if="clinic.photoUrl">
            <img :src="clinic.photoUrl" :alt="`${clinic.name} logo`"/>
        </div>
    </div>
</template>

<script setup>

    const props = defineProps({
        clinic: Object
    })

</script>

<style scoped lang="scss">
@use '../../../assets/scss/breakpoints'  as *;

    img {
        width: 80px;
        height: 60px;
    }
    .image {
        display: flex;
        justify-content: center;
        margin-right: var(--spacing-sm);

        @include small-up {
            display: block;
        }
    }


</style>